module.exports = __webpack_public_path__ + "assets/img/yesLog.0fcf5cc4.png";